import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-successfully-sent-annex-to-approval',
  templateUrl: './successfully-sent-annex-to-approval.component.html',
  styleUrls: ['./successfully-sent-annex-to-approval.component.scss'],
  standalone: false,
})
export class SuccessfullySentAnnexToApprovalComponent {
 @Input() workerId: number;
}
